interface ApiErrorItem {
  field: string;
  message: string;
}

interface ParsedErrors {
  fieldErrors: Record<string, string>;
  generalMessage: string;
}

export function parseApiError(errorData: unknown): ParsedErrors {
  const fieldErrors: Record<string, string> = {};
  let generalMessage = 'Произошла ошибка';

  // Если это массив ошибок с полями
  if (Array.isArray(errorData)) {
    errorData.forEach((error: ApiErrorItem) => {
      if (error.field && error.message) {
        fieldErrors[error.field] = error.message;
      }
    });

    // Создаем общее сообщение из всех ошибок
    if (Object.keys(fieldErrors).length > 0) {
      generalMessage = Object.values(fieldErrors).join('. ');
    }
  }
  // Если это объект с message
  else if (
    errorData &&
    typeof errorData === 'object' &&
    'message' in errorData &&
    typeof (errorData as { message: unknown }).message === 'string'
  ) {
    generalMessage = (errorData as { message: string }).message;
  }
  // Если это строка
  else if (typeof errorData === 'string') {
    generalMessage = errorData;
  }

  return {
    fieldErrors,
    generalMessage,
  };
}

export function safeParseApiError(error: unknown): ParsedErrors {
  const errorData =
    error && typeof error === 'object' && 'data' in error
      ? (error as { data: unknown }).data
      : error;

  return parseApiError(errorData);
}
